import * as React from 'react';
import { config } from '../../config';
import { Link } from '../Link';
import { clearFilterParams } from '../../actions/searchActions';

const styles: Record<string, React.CSSProperties> = {
    logoWrapper: {
        flex: '1 1 auto',
        paddingRight: 10,
    },
    logoLink: {
        display: 'inherit',
        maxWidth: '195px',
        height: '42px',
    },
    logoImg: {
        maxWidth: '100%',
        height: '42px',
        display: 'block',
    },
};

interface IProps {
    clearFilterParams: typeof clearFilterParams;
    portalId: string;
    forceReload?: boolean;
}

export class Logo extends React.Component<IProps, any> {
    clearFilterParams = () => {
        this.props.clearFilterParams(false);
    };

    render() {
        return (
            <div style={styles.logoWrapper}>
                <Link
                    href="/"
                    style={styles.logoLink}
                    onClick={this.clearFilterParams}
                    forceReload={this.props.forceReload}
                >
                    <img
                        style={styles.logoImg}
                        src={`${config.images}/${this.props.portalId}/logo.svg`}
                        alt="Dreamlines logo"
                        title="Dreamlines"
                    />
                </Link>
            </div>
        );
    }
}
